<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent custom-100">
        <b-row>
            <b-col>
                <div style=" padding: 5px 10px 4px;border-bottom: 1px solid gray; ">
                    <b-row>
                        <b-col md="2">
                            <b-form-input class="black" v-model="search" type="text" placeholder="Tourname">
                            </b-form-input>
                        </b-col>
                        <b-col md="2" style="padding-right: 8px">
                            <b-button variant="primary" style="margin-left: 8px" class="px-4" v-on:click="onSearch">Anwenden</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row class="custom-flex-1">
            <b-col sm="12">
                <b-card no-body style="border: none; height: 100%; margin: 0;">
                    <b-table striped bordered hover responsive id="my-table"
                             class="custom-auto-height" no-local-sorting
                             :current-page="currentPage" :per-page="0" :fields="fields" :items="items">
                        <template v-slot:cell(controls)="row">
                            <b-button variant="primary" size="sm" v-if="!row.detailsShowing" @click="row.toggleDetails">
                                <i class="fa fa-chevron-down"></i>
                            </b-button>
                            <b-button variant="primary" size="sm" v-if="row.detailsShowing" @click="row.toggleDetails">
                                <i class="fa fa-chevron-up"></i>
                            </b-button>
                            <delete-icon v-if="planable || (sendable && row.item.group === '')"
                                    class="icon-2x ml-2 hoverable-icon" fillColor="#f44336" :size="76"
                                    style="color: #f44336;vertical-align: middle; margin-bottom: 6px" v-on:click="deleteTaskTour(row.item.id)"
                            ></delete-icon>

                        </template>
                        <template v-slot:row-details="data">
                            <md-card>
                                <b-row>
                                    <b-col>
                                        <b-table striped bordered responsive :items="data.item.tasks" :fields="fields_task"
                                                 thead-class="white" thead-tr-class="white" style="margin-bottom: 0">
                                            <template v-slot:cell(priority)="row">
                                                <b-row style="margin: 0" v-if="row.item.priority === 3">
                                                    <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: red"></div>
                                                    <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                                        Hoch</p>
                                                </b-row>
                                                <b-row style="margin: 0" v-if="row.item.priority === 1">
                                                    <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: green"></div>
                                                    <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                                        Niedrig</p>
                                                </b-row>
                                                <b-row style="margin: 0" v-if="row.item.priority === 2">
                                                    <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: yellow"></div>
                                                    <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                                        Mäßig</p>
                                                </b-row>
                                            </template>
                                            <template v-slot:cell(image_url)="row">
                                                <image-icon v-if="row.item.image_url !== ''"
                                                            title="Bilder"
                                                            v-on:click="showImage(row.item.image_url, row.item.id)"
                                                            class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                            style="color: green"></image-icon>
                                            </template>
                                            <template v-slot:cell(controls)="row">
                                                <check-icon v-if="row.item.finish_date === null"
                                                            title="Fertigstellen"
                                                            class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                            style="color: green"  v-on:click="finishTask(row.item.id, data.item.id)"
                                                >
                                                </check-icon>
                                            </template>
                                            <template v-slot:cell(tools)="row">
                                                {{formateTools(row.item.tools)}}
                                            </template>
                                            <template v-slot:cell(is_planned)="row">
                                                {{formateBool(row.item.is_planned)}}
                                            </template>
                                            <template v-slot:cell(create_date)="row">
                                                {{dateFormater(row.item.create_date)}}
                                            </template>
                                            <template v-slot:cell(finish_date)="row">
                                                {{dateFormater(row.item.finish_date)}}
                                            </template>
                                            <template v-slot:cell(open)="data">
                                                <open-icon  v-on:click="openTask(data.item.id)"
                                                            title="Öffnen"
                                                            class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                            style="color: green"></open-icon>
                                            </template>
                                          <template v-slot:cell(unplan)="row">
                                            <remove-icon v-if="useExtern && data.item.group === 'EX' && row.item.finish_date === null"
                                                v-on:click="onUnplanTask(data.item.id, row.item.id)"
                                                        title="Planung aufheben"
                                                        class="icon-1_5x ml-2 hoverable-icon" fillColor="#f44336" :size="72"
                                                        style="color: red"></remove-icon>
                                          </template>
                                        </b-table>
                                    </b-col>
                                </b-row>
                                <b-row v-if="useExtern && data.item.group === 'EX'" class="m-3 pb-3">
                                        <b-button variant="primary" style="margin-left: 8px" class="px-4" v-on:click="showLinkExternal(data.item)">Externen Link anzeigen</b-button>
                                    <b-button variant="primary" style="margin-left: 8px" class="px-4" v-on:click="showQrExternal(data.item)">Externen QR-Code anzeigen</b-button>
                                    <b-button variant="success" style="margin-left: 8px" class="px-4" v-on:click="showLinkExternalWithPermission(data.item)">Externen Link mit Berechtigung anzeigen</b-button>
                                        <b-button variant="success" style="margin-left: 8px" class="px-4" v-on:click="showPermissionPwdExternal(data.item)">Berechtigungspasswort für App anzeigen</b-button>
                                </b-row>
                            </md-card>
                        </template>
                    </b-table>
                    <div class="mt-3 custom-flex-0">
                        <b-pagination align="center"
                                      v-model="currentPage"
                                      :per-page="perPage"
                                      :total-rows="totalItems"></b-pagination>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null">
        </CoolLightBox>
        <b-modal
                centered
                v-model="show_delete"
                title="Maßnahme löschen"
                cancel-title="Abbrechen"
                ok-title="Löschen"
                ok-variant="danger"
                @ok="onDelete"
        >Möchten Sie diese Maßnahme wirklich löschen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>
        <b-modal
                centered
                v-model="show_finish"
                title="Maßnahme fertigstellen"
                cancel-title="Abbrechen"
                ok-title="Fertigstellen"
                @ok="onFinish"
                ok-variant="success"
        >Möchten Sie diese Maßnahme fertigstellen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>

        <b-modal class="p-0" hide-footer hide-header centered body-class="modal-body-no-p" v-model="showQr">
            <template style="padding: 0;" #default="{ hide }">
                <b-card no-body class="p-4 mb-0">
                    <b-card-body>
                        <qrcode :background="background" :size="size" :cls="qrCls" :value="qrText"></qrcode>
                    </b-card-body>
                </b-card>
            </template>
        </b-modal>
        <b-modal class="p-0" hide-footer hide-header centered body-class="modal-body-no-p" v-model="LinkExternalShowing">
            <template style="padding: 0;" #default="{ hide }">
                <b-card no-body class="p-2 mb-0">
                    <b-card-body>
                        <b-row>
                            <b-col md="8"><b-form-input v-on:focus="$event.target.select()" ref="link_external" class="black" v-model="linkExternal" type="text" readonly>
                            </b-form-input>
                            </b-col>
                            <b-col md="4">
                            <b-button variant="primary" style="margin-left: 8px" class="px-4" v-on:click="onCopyLinkExternal">Kopieren</b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                            <b-alert class="mb-0 mt-4"
                                    :show="dismissCountDown"
                                    dismissible
                                    variant="success"
                                    @dismissed="dismissCountDown=0"
                                    @dismiss-count-down="countDownChanged"
                            >
                                Erfolgreich in den Zwischenspeicher kopiert
                            </b-alert>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import {Server_URL} from "../../shared/utils";
    import OpenIcon from 'vue-material-design-icons/OpenInNew.vue';
    import ImageIcon from 'vue-material-design-icons/Image.vue';
    import TextIcon from 'vue-material-design-icons/CommentText.vue';
    import RemoveIcon from 'vue-material-design-icons/PencilRemoveOutline.vue'
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
    import DeleteIcon from 'vue-material-design-icons/Delete.vue';
    import CheckIcon from 'vue-material-design-icons/CheckCircle';
    import Qrcode from 'v-qrcode/src/index'



    export default {
        name: "task_plannings",
        components: {
            OpenIcon,
            ImageIcon,
            TextIcon,
            CoolLightBox,
            DeleteIcon,
            CheckIcon,
            Qrcode,
          RemoveIcon
        },
        mounted() {

          this.parseQuery();
          this.$nextTick(() => {
            this.fetchData();
          });
        },
        data: () => {
            return {
                loader: undefined,
                currentPage: 1,
                perPage: 15,
                totalItems: 5000,
                items: [],
                index: null,
                wasMounted: false,
                images: [
                    '',
                ],
                fields: [
                    {key: 'date', label: "Datum", formatter: 'dateFormater'},
                    {key: 'name', label: "Name"},
                    {key: 'group', label: "Gruppe", formatter: 'groupFormater'},
                    {key: 'finished', label: "Anz. Erledigt"},
                    {key: 'open', label: "Anz. Austehend"},
                    {key: 'total', label: "Anz. Gesamt"},
                    {key: 'finished_at', label: "Abgeschlossen am", formatter: 'dateFormater'},
                    {key: 'created_at', label: "Erstellt am", formatter: 'dateFormater'},
                    {key: 'controls', label: ""},
                ],
                fields_task: [
                    {key: "priority", label: "Priorität"},
                    {key: "tree_number", label: "Baumnummer"},
                    {key: "name", label: "Maßnahme"},
                    {key: "tools", label: "Hilfsmittel"},
                    {key: "note", label: "Notiz"},
                    {key: "image_url", label: "Bilder"},
                    {key: "is_planned", label: "Beplant", formatter: 'formateBool'},
                    {key: "create_date", label: "Datum", formatter: 'dateFormater'},
                    {key: "finish_date", label: "Erledigt", formatter: 'dateFormater'},
                    {key: "controls", label: ""},
                    {key: "open", label: ""},
                    {key: "unplan", label: ""},
                ],
                search: "",
                show_delete: false,
                show_finish: false,
                current_id: null,
                current_task: null,
                planable: false,
                sendable: false,
                useExtern: false,
                showQr: false,
                qrCls: 'qrcode',
                qrText: '',
                size: 500,
                background: '#ffffff',
                customerNumber: "",
                LinkExternalShowing: false,
                linkExternal: "",
                showCopyOkExternal: false,
                dismissCountDown: 0,

              unplanTaskTour: null,
              unplanTask: null,
            }
        },
        watch: {
            currentPage: {
                handler: function(value) {
                  if (this.wasMounted) {
                    this.fetchData();
                  }
                }
            }
        },
        methods: {
            openTask(id) {
                this.$router.push("/tasks/task/"+id);
            },
            showImage(image, taskId) {
                let imgs = image.split("||");
                this.images = [];
                for (let i = 0; i < imgs.length; i++) {
                    if (imgs[i] !== "") {
                        this.images.push(Server_URL + '/baumkontrolle/task/image' + "?task_id=" + taskId + "&image_name=" + imgs[i]);
                    }
                }
                this.index = 0;
            },
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },

            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.totalItems = response.data.total;
                    this.items = response.data.task_tours;
                    this.planable = response.data.planable;
                    this.sendable = response.data.sendable;
                    this.useExtern = response.data.use_extern;
                    this.customerNumber = response.data.customer_number;
                } else {
                    console.log(response);
                }
            },
            onSearch() {
                let befor = this.currentPage;
                this.currentPage = 1;
                if (befor === this.currentPage) {
                    this.fetchData();
                }
            },
            getQuery() {
                let query = "?limit=" + this.perPage;
                query += "&page=" + (this.currentPage - 1);
                if (this.search.trim() !== "") {
                    query += "&query=" + encodeURIComponent(this.search.trim());
                }
                this.setQuery();
                return query;
            },
            fetchData() {
              this.wasMounted = true;
              this.showLoader();
                this.$http.get(
                    Server_URL + '/baumkontrolle/task_tours' + this.getQuery()
                ).then(this.responseOkGet, this.responseError)
            },
            deleteTaskTour(id) {
                this.current_id = id;
                this.show_delete = true;
            },
            onDelete() {
                if (this.current_id !== null) {
                    this.showLoader();
                    this.$http.delete(
                        Server_URL + '/baumkontrolle/task_tour/' + this.current_id
                    ).then(this.responseOkDelete, this.responseError);
                }
            },
            responseOkDelete(response) {
                this.hideLoader()
                if (response.status === 200) {
                    for (let i = 0; i < this.items.length; i++) {
                        let current = this.items[i];
                        if (current.id === this.current_id) {
                            this.items.splice(i, 1);
                            break;
                        }
                    }
                    this.current_id = null;
                    this.currentTask = null;
                } else {
                    console.log(response);
                }
            },
            formateTools(value) {
                if (value === null || value === "") {
                    return ""
                }
                let res = value.split("||")
                let ret = res[0]
                for (let i = 1; i < res.length; i++) {
                    if (res[i] !== "") {
                        ret += ", " + res[i];
                    }
                }
                return ret;

            },
            formateBool(value) {
                if (value === true) {
                    return "Ja"
                }  else {
                    return "Nein"
                }
            },
            dateFormater(value) {
                if (value === null) {
                    return ""
                }
                let event = new Date(value.replace('Z',''));
                let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return event.toLocaleDateString('de-DE', options);
            },
            groupFormater(value) {
                if (value === null) {
                    return ""
                }
                if (this.useExtern && value === "EX") {
                    return "Vergabe Extern";
                }
                return value;
            },
            finishTask(id, tour_id) {
                this.current_id = tour_id;
                this.currentTask = id;
                this.show_finish = true;
            },
            onFinish() {
                if (this.currentTask !== null) {
                    this.showLoader();
                    this.$http.patch(
                        Server_URL + '/baumkontrolle/task/' + this.currentTask
                    ).then(this.responseOkFinish, this.responseError);
                    this.currentTask = null;
                }
            },
            responseOkFinish(response) {
                this.hideLoader()
                if (response.status === 200) {
                    for (let i = 0; i < this.items.length; i++) {
                        let current = this.items[i];
                        if (current.id === this.current_id) {
                            for (let j = 0; j < current.tasks.length; j++) {
                                if (current.tasks[j].id === this.currentTask) {
                                    this.items[i].tasks[j].finish_date = "" + new Date();
                                    break;
                                }
                            }
                            current.open -= 1;
                            current.finished += 1;
                            if (current.open === 0) {
                                current.finished_at = "" + new Date();
                            }
                        }
                    }
                    this.current_id = null;
                    this.currentTask = null;
                } else {
                    console.log(response);
                }
            },
            showLinkExternal(data) {
                this.linkExternal = Server_URL + "/#/tasks/all?customer_external="+this.customerNumber+"&external_key="+data.external_id;
                this.LinkExternalShowing = true;
            },
            showLinkExternalWithPermission(data) {
                this.linkExternal = Server_URL + "/#/tasks/all?customer_external="+this.customerNumber+"&external_key="+data.external_id + "&permission="+data.external_permission;
                this.LinkExternalShowing = true;
            },
            showQrExternal(data) {
                let qrData = {
                    customer_number: this.customerNumber,
                    external_id: data.external_id,
                };
                this.qrText = JSON.stringify(qrData);
                this.showQr = true;
            },
            showPermissionPwdExternal(data) {
                this.linkExternal = data.external_permission;
                this.LinkExternalShowing = true;
            },
            onCopyLinkExternal() {
                this.$refs.link_external.focus();
                document.execCommand('copy');
                this.dismissCountDown = 2;
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
          onUnplanTask(taskTourId, taskTourTaskId) {
              this.unplanTaskTour = taskTourId
            this.unplanTask = taskTourTaskId
            this.showLoader();
            this.$http.delete(
                Server_URL + '/baumkontrolle/task_tour_task/' + this.unplanTask
            ).then(this.onResponseUnplanOk, this.responseError);
          },
          onResponseUnplanOk(response) {
            this.hideLoader();
            if (response.status === 200) {
              for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].id === this.unplanTaskTour) {
                  let tour = this.items[i];
                  let indexTask = -1;
                  for (let j = 0; j < tour.tasks.length; j++) {
                    if (tour.tasks[j].id === this.unplanTask) {
                      indexTask = j;
                      break;
                    }
                  }
                  if (indexTask !== -1) {
                    this.items[i].tasks.splice(indexTask, 1);
                    if (this.items[i].tasks.length === 0) {
                      this.items.splice(i, 1);
                    }
                  }
                }
              }
            } else {
              console.log(response);
            }
          },
          parseQuery() {
            let query = this.$route.query;
            if (query.limit !== undefined) {
              this.perPage = parseInt(query.limit);
            }
            if (query.page !== undefined) {
              this.currentPage = parseInt(query.page)+1;
            }
            if (query.search !== undefined) {
              this.search = query.search;
            }
          },
          setQuery() {
            let query = {
              limit: this.perPage,
              page: this.currentPage-1,
              search: this.search,
            }
            this.$router.push({query: query}).then(() => {}).catch(err => {});
          }
        }
    }
</script>
<style>
    .custom-100 {
        height: 100%;
        display: flex;
        flex-direction: column;
        -ms-flex-direction: column;
        -webkit-flex-direction: column;
    }

    .custom-flex-1 {
        flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        -webkit-flex: 1;
    }

    .custom-auto-height {
        flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        -webkit-flex: 1;
        max-height: 100%;
    }

    .custom-flex-0 {
        flex: 0;
        -moz-box-flex: 0;
        -ms-flex: 0;
        -webkit-flex: 0;
    }

    .black {
        color: black;
    }
    .white {
        background-color: white !important;
    }

</style>

<style scoped>

    .hoverable-icon:hover {
        cursor: pointer;
    }
</style>
